import { Conversation } from '@11labs/client';

// --- Referências aos Elementos HTML ---
const startButton = document.getElementById('startButton');
const stopButton = document.getElementById('stopButton');
const connectionStatusEl = document.getElementById('connectionStatus');
const agentStatusEl = document.getElementById('agentStatus');
const inputMeterEl = document.getElementById('inputMeter');
const outputMeterEl = document.getElementById('outputMeter');
const transcriptListEl = document.getElementById('transcriptList');
const errorMessageEl = document.getElementById('errorMessage'); // Elemento para mensagens de erro
const nomeInputEl = document.getElementById('nomeInput');
const tomInputEl = document.getElementById('tomInput');
const personalidadeInputEl = document.getElementById('personalidadeInput');
// voiceId removido do frontend por segurança
const agentSelectEl = document.getElementById('agentSelect');
const overrideFirstMessageInputEl = document.getElementById('overrideFirstMessageInput');
const configEl = document.getElementById('config');
const languageSelectEl = document.getElementById('languageSelect');

let conversation = null; // Guarda a instância da conversa
let volumeUpdateInterval = null;

// --- Funções Auxiliares ---
function updateStatusUI(connectionStatus, agentStatus = '-', errorMsg = '') {
    connectionStatusEl.textContent = connectionStatus;
    agentStatusEl.textContent = agentStatus;
    errorMessageEl.textContent = errorMsg; // Mostra a mensagem de erro

    const isConnecting = connectionStatus === 'Conectando...' || connectionStatus === 'Solicitando permissão...' || connectionStatus === 'Obtendo URL...';
    const isConnected = connectionStatus === 'Conectado';

    startButton.disabled = isConnecting || isConnected;
    stopButton.disabled = !isConnected;
}

function addMessageToTranscript(role, text) {
    if (!text || text.trim() === '') return; // Não adiciona mensagens vazias ou só com espaços
    const li = document.createElement('li');
    const prefix = role === 'user' ? 'Você' : 'Recepcionista';
    li.textContent = `${prefix}: ${text}`;
    li.className = role === 'user' ? 'user-message' : 'agent-message';
    transcriptListEl.appendChild(li);
    // Auto-scroll para a última mensagem
    transcriptListEl.scrollTop = transcriptListEl.scrollHeight;
}

async function fetchSignedUrl() {
    try {
        // Envia apenas a chave segura do agente (não o ID)
        const selectedAgentKey = agentSelectEl?.value || 'default';
        // Usa caminho relativo para funcionar em dev (localhost) e prod (mesma origem)
        const url = `/get-signed-url?agent_key=${encodeURIComponent(selectedAgentKey)}`;

        const response = await fetch(url);
        if (!response.ok) {
             let errorData = { error: `Erro ${response.status}: ${response.statusText}` };
             try {
                 errorData = await response.json();
             } catch (e) { /* Ignora erro de parse se não for JSON */ }
             console.error("Erro do Backend ao buscar Signed URL:", errorData);
             throw new Error(`Falha ao obter signed URL: ${errorData.error || response.statusText}`);
        }
        const data = await response.json();
        if (!data.signedUrl) {
            console.error("Resposta do Backend inválida:", data);
            throw new Error("Backend não retornou uma signed URL válida.");
        }
        console.log("Signed URL recebida do backend.");
        return data.signedUrl;
    } catch (error) {
        console.error("Erro de rede ou do backend ao buscar signed URL:", error);
        updateStatusUI('Erro Backend', '-', error.message);
        throw error; // Re-throw para interromper o início da conversa
    }
}

async function fetchAgentParams(agentKey) {
    try {
        const res = await fetch(`/agent-params?agent_key=${encodeURIComponent(agentKey)}`);
        if (!res.ok) return {};
        const data = await res.json();
        return data?.dynamicVariables || {};
    } catch (e) {
        console.warn('Falha ao obter parâmetros do agente:', e);
        return {};
    }
}

// --- Funções de Controle da Conversa ---
async function startConversation() {
    updateStatusUI('Solicitando permissão...', '-', ''); // Limpa erro anterior
    transcriptListEl.innerHTML = ''; // Limpa transcrição anterior
    try {
        // 0. Ler valores dos inputs das variáveis dinâmicas
        const nomeValue = nomeInputEl.value.trim();
        const tomValue = tomInputEl.value.trim();
        const personalidadeValue = personalidadeInputEl.value.trim();
        const overrideFirstMessageValue = `Obrigada por ligar para a Action Cargo! Sou ${nomeValue}, como posso ajudar?`
        // console.log("Variáveis Dinâmicas:", { nome: nomeValue, tom_voz: tomValue, personalidade: personalidadeValue, mensagem: overrideFirstMessageValue }); // Log

        // Bloqueia seleção de agente durante conversa
        if (agentSelectEl) agentSelectEl.disabled = true;
        if (languageSelectEl) languageSelectEl.disabled = true;

        // 1. Solicitar permissão do microfone
        await navigator.mediaDevices.getUserMedia({ audio: true });
        console.log("Permissão do microfone concedida.");
        updateStatusUI('Obtendo URL...', '-', '');

        // 2. Obter a Signed URL do backend
        const signedUrl = await fetchSignedUrl();
        updateStatusUI('Conectando...', '-', '');

        // *** Construir o objeto de Overrides ***
        const overrideConfig = { agent: {} };
        // Define idioma selecionado como override para o agente
        const langCode = (languageSelectEl && languageSelectEl.value) ? languageSelectEl.value : 'pt';
        overrideConfig.agent.language = langCode;

        // Define dynamicVariables conforme o agente
        const agentKey = agentSelectEl?.value || 'default';
        let dynamicVariables = {};
        if (agentKey === 'default') {
            // Padrão: usa campos do frontend e primeira mensagem amigável
            if (overrideFirstMessageValue) {
                overrideConfig.agent.first_message = overrideFirstMessageValue;
            }
            dynamicVariables = {
                nome: nomeValue || "Tina",
                tom_voz: tomValue || "neutro",
                personalidade: personalidadeValue || "padrão"
            };
        } else {
            // Outros agentes: obtém parâmetros no backend (hardcoded por enquanto)
            dynamicVariables = await fetchAgentParams(agentKey);
        }

        // Limpa objeto agent se vazio
        if (Object.keys(overrideConfig.agent).length === 0) delete overrideConfig.agent;

        console.log("Overrides:", overrideConfig, "DynamicVariables:", dynamicVariables);

        // 3. Iniciar a sessão com a @11labs/client
        conversation = await Conversation.startSession({
            signedUrl: signedUrl, // Usar a URL assinada

            dynamicVariables,

            // *** Passar o objeto de overrides ***
            overrides: overrideConfig,

            // Callbacks para atualizar a UI e lidar com eventos
            onConnect: (conversationId) => {
                console.log("Conectado! ID da Conversa:", conversationId);
                updateStatusUI('Conectado', 'Ouvindo', ''); // Começa ouvindo
                startVolumeUpdates();
            },
            onDisconnect: () => {
                console.log("Desconectado.");
                updateStatusUI('Desconectado', '-', '');
                stopVolumeUpdates();
                conversation = null;
                if (agentSelectEl) agentSelectEl.disabled = false; // Reabilita troca de agente
                if (languageSelectEl) languageSelectEl.disabled = false;
            },
            onMessage: (event) => {
                // console.log("Evento onMessage (formato da biblioteca):", JSON.stringify(event, null, 2));

                let role = null;
                let text = null;

                // Verifica a estrutura { source, message }
                if (event.source === 'ai' && typeof event.message === 'string') {
                    role = 'agent';
                    text = event.message;
                    // console.log(`[Processado Biblioteca] Resposta Agente: ${text}`);
                } else if (event.source === 'user' && typeof event.message === 'string') {
                    // Assumindo que a transcrição do usuário virá como { source: 'user', message: '...' }
                    role = 'user';
                    text = event.message;
                    // console.log(`[Processado Biblioteca] Transcrição Usuário: ${text}`);
                } else {
                    // Log se a estrutura for algo inesperado
                    console.warn("[Aviso] Evento onMessage com estrutura desconhecida pela biblioteca:", event);
                }

                // Adiciona à UI se tivermos um role e texto válidos
                if (role && text) {
                    addMessageToTranscript(role, text);
                }
            },
            onError: (error, info) => {
                const errorText = info?.message || error?.message || 'Erro desconhecido na conexão';
                console.error("Erro na conversa:", error, info);
                updateStatusUI('Erro Conexão', '-', errorText);
                stopVolumeUpdates();
                if (conversation) {
                    // Tenta encerrar a sessão se ainda existir
                    try { conversation.endSession(); } catch (e) { /* ignora */ }
                }
                conversation = null;
                if (agentSelectEl) agentSelectEl.disabled = false;
                if (languageSelectEl) languageSelectEl.disabled = false;
            },
            onModeChange: (mode) => { // Atualiza se o agente está ouvindo ou falando
                console.log("Modo do agente:", mode.mode);
                // Só atualiza se estiver conectado
                if (connectionStatusEl.textContent === 'Conectado') {
                    agentStatusEl.textContent = mode.mode === 'speaking' ? 'Falando' : 'Ouvindo';
                }
            }
        });

    } catch (error) {
        console.error('Falha ao iniciar a conversa:', error);
         if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
             updateStatusUI('Permissão Negada', '-', 'Permissão do microfone negada.');
         } else if (!errorMessageEl.textContent) { // Só atualiza se não houver erro do backend
             updateStatusUI(`Erro ao Iniciar`, '-', error.message);
         }
         // Garante que botões estejam no estado correto se falhar
         startButton.disabled = false;
         stopButton.disabled = true;
        stopVolumeUpdates();
        conversation = null;
        if (agentSelectEl) agentSelectEl.disabled = false; // Reabilita seleção
        if (languageSelectEl) languageSelectEl.disabled = false;
    }
}

function stopConversation() {
    if (conversation) {
        console.log("Parando a conversa...");
        updateStatusUI('Desconectando...', '-', '');
        try {
            conversation.endSession();
        } catch (error) {
             console.error("Erro ao chamar endSession:", error);
             // Força a atualização da UI mesmo se endSession falhar
             updateStatusUI('Desconectado', '-', '');
             stopVolumeUpdates();
             conversation = null;
        }
        // O callback onDisconnect deve lidar com a limpeza final
    } else {
        console.warn("Nenhuma conversa ativa para parar.");
        updateStatusUI('Desconectado', '-', ''); // Garante estado correto da UI
        stopButton.disabled = true;
        startButton.disabled = false;
        if (agentSelectEl) agentSelectEl.disabled = false;
        if (languageSelectEl) languageSelectEl.disabled = false;
    }
}

// --- Funções de Atualização de Volume ---
function startVolumeUpdates() {
    stopVolumeUpdates(); // Limpa intervalo anterior, se houver

    volumeUpdateInterval = setInterval(async () => {
        // Verifica se a conversa existe E se a UI ainda mostra 'Conectado'
        if (conversation && connectionStatusEl.textContent === 'Conectado') {
            try {
                 // Adiciona uma verificação extra aqui dentro do try
                 if (connectionStatusEl.textContent !== 'Conectado') {
                    stopVolumeUpdates(); // Para se desconectou entre a verificação externa e aqui
                    return;
                 }
                 const inputVol = await conversation.getInputVolume();
                 const outputVol = await conversation.getOutputVolume();

                 // Verifica novamente após chamadas async, pois o estado pode ter mudado
                 if (connectionStatusEl.textContent !== 'Conectado') {
                     stopVolumeUpdates();
                     return;
                 }

                 // Suaviza a atualização para evitar piscadas rápidas
                 inputMeterEl.value = inputMeterEl.value * 0.3 + inputVol * 0.7;
                 outputMeterEl.value = outputMeterEl.value * 0.3 + outputVol * 0.7;
            } catch (error) {
                 // Erros ao obter volume podem ocorrer se a conexão fechar abruptamente.
                 // Verifica se o erro é sobre o estado do WebSocket para evitar logs excessivos.
                 if (error instanceof Error && error.message.includes('WebSocket is already in CLOSING or CLOSED state')) {
                    // console.warn("Tentativa de obter volume em WebSocket fechado/fechando.");
                 } else {
                    console.warn("Erro ao obter volume:", error);
                 }
                 stopVolumeUpdates(); // Para o intervalo se houver erro
            }
        } else {
            stopVolumeUpdates(); // Para se a conversa não existe mais ou desconectou
        }
    }, 150); // Atualiza a cada 150ms para suavizar
}

function stopVolumeUpdates() {
    if (volumeUpdateInterval) {
        clearInterval(volumeUpdateInterval);
        volumeUpdateInterval = null;
    }
    // Reset suave dos medidores
     let resetInterval = setInterval(() => {
         inputMeterEl.value *= 0.8;
         outputMeterEl.value *= 0.8;
         if (inputMeterEl.value < 0.01 && outputMeterEl.value < 0.01) {
             inputMeterEl.value = 0;
             outputMeterEl.value = 0;
             clearInterval(resetInterval);
         }
     }, 50);

}


// --- Event Listeners ---
startButton.addEventListener('click', startConversation);
stopButton.addEventListener('click', stopConversation);

// Atualiza os campos de "Tom de Voz" e "Personalidade" ao mudar a recepcionista
nomeInputEl.addEventListener('change', (event) => {
    const selectedOption = event.target.selectedOptions[0];
    tomInputEl.value = selectedOption.getAttribute('data-tom');
    personalidadeInputEl.value = selectedOption.getAttribute('data-personalidade');
});

// Mostrar/ocultar bloco de configuração com base no agente selecionado
function updateConfigVisibility() {
    const key = agentSelectEl?.value || 'default';
    if (configEl) {
        configEl.style.display = key === 'default' ? 'block' : 'none';
    }
}

// Ao trocar de agente: limpar transcrição e ajustar UI
if (agentSelectEl) {
    agentSelectEl.addEventListener('change', () => {
        transcriptListEl.innerHTML = '';
        updateConfigVisibility();
    });
}

// --- Inicialização ---
updateStatusUI('Desconectado'); // Estado inicial da UI
updateConfigVisibility();

console.log("Frontend pronto. Aguardando interação.");
